

import React from 'react';

import TabPanel from './TabPanel';
import HomePanel from './HomePanel';

const renderTabPanelHome = (props) => {
    return (
        <TabPanel key={props.name} name={props.name} iconName={props.iconName} title={props.title}>
            <HomePanel 
                content={props.appConfig.home.content}
            />
        </TabPanel>
    );
}

export default renderTabPanelHome;
